import { createContext } from 'react';
import type { ClassFeature, Feat, Item, Spell } from '../types';

export type CardVariant = 'spells' | 'items' | 'classes' | 'feats';

export interface CardEntityByVariant {
  spells: Spell;
  items: Item;
  classes: ClassFeature;
  feats: Feat;
}

export type SelectedCard = {
  [V in CardVariant]: {
    key: string;
    variant: V;
    entity: CardEntityByVariant[V];
  };
}[CardVariant];

export interface SelectionContextValue {
  selectedCards: SelectedCard[];
  selectedCount: number;
  globalBorderColor: string;
  setGlobalBorderColor: (color: string) => void;
  isSelected: (variant: CardVariant, entityId: string) => boolean;
  toggleCard: <V extends CardVariant>(variant: V, entity: CardEntityByVariant[V]) => void;
  addCards: <V extends CardVariant>(variant: V, entities: CardEntityByVariant[V][]) => void;
  clearAllCards: () => void;
  getCardBorderColor: (variant: CardVariant, entityId: string) => string | undefined;
  setCardBorderColor: (variant: CardVariant, entityId: string, color: string) => void;
  applyBorderColorToAll: () => void;
}

export const SelectionContext = createContext<SelectionContextValue | null>(null);
